import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import ListItemButton from '@mui/material/ListItemButton';
import constants from 'helpers/constants';
import utils from 'helpers/utils';

const StyledListItemButton = styled(ListItemButton)
  .attrs((props) => {
    let attr = props;

    const baseColorVars = props.theme.color2Css('ListItemButton', null, props.$color, {
      varPrefix: 'list-item-button',
      variables: true,
      interactive: true,
      type: constants.colorTypes.accentBackground
    });

    attr = utils.styleProps(attr, baseColorVars.vars, {baseColor: baseColorVars.css});

    const directionalColorVars = props.theme.color2Css('ListItemButton', null, props.$color, {
      varPrefix: 'list-item-button',
      variables: true,
      interactive: true,
      type: constants.colorTypes.outlined
    });

    return utils.styleProps(attr, directionalColorVars.vars, {directionalColor: directionalColorVars.css});
  })`
  ${props => props.$css.baseColor}

  &.Skeleton {
    width: 100%;
    max-width: unset;
    transform: unset;
  }
  
  &.ListItemButton-directional {
    ${props => props.$css.directionalColor}
    
    &.ListItemButton {
      border-radius: ${props => props.theme.radius(2)};
      border: ${props => props.theme.layout(1)} solid ${props => props.theme.property('palette.divider')};
      border-color: ${props => props.theme.property('palette.divider')} !important;

      .ListItemButton-directionIcon {
        color: ${props => props.theme.property('palette.divider')};
      }

      ${props => props.theme.state2Selector('ListItemButton', 'ListItemButton-directionIcon', ['hover', 'active', 'focus', 'focusVisible', 'selected'])} {
        color: ${props => props.theme.property('palette.text.disabled')};
      }
    }

    ${props => ['up', 'down'].includes(props.$direction) && css`
      flex-wrap: wrap;
      .ListItemButton-directionIcon {
        display: flex;
        width: 100%;
        justify-content: center;
      }
    `}
    ${props => ['left', 'right'].includes(props.$direction) && css`
      .ListItemButton-directionIcon {
        display: flex;
        align-items: center;
      }
    `}
    ${props => props.$direction === 'left' && css`
      flex-direction: row-reverse;
      .ListItemText {
        text-align: right;
      }
      .ListItemIcon {
        justify-content: flex-end;
      }
    `}
    ${props => props.$direction === 'right' && css`
      .ListItemText + .ListItemIcon {
        justify-content: flex-end;
      }
    `}
  }
  
  ${ComponentStyles}
`;

StyledListItemButton.propTypes = {
  theme: PropTypes.object
};

export default StyledListItemButton;
